import { render, staticRenderFns } from "./ClinicIncomeReport.vue?vue&type=template&id=65d91fbf&scoped=true"
import script from "./ClinicIncomeReport.vue?vue&type=script&lang=js"
export * from "./ClinicIncomeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d91fbf",
  null
  
)

export default component.exports